module.exports = __webpack_public_path__ + "static/crealityk1-faaa5831c1fb3c72eb2de73b324f7913.png";